import { render, staticRenderFns } from "./CriteriaNotMetTable.vue?vue&type=template&id=7fd9e1b9&scoped=true&"
import script from "./CriteriaNotMetTable.vue?vue&type=script&lang=js&"
export * from "./CriteriaNotMetTable.vue?vue&type=script&lang=js&"
import style0 from "./CriteriaNotMetTable.vue?vue&type=style&index=0&id=7fd9e1b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fd9e1b9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
